import { TaxQuestionKey } from "./taxSavingRules";

export const CATEGORIZE_ACTION = "CATEGORIZE";
export const TRANSFER_MATCH_ACTION = "TRANSFER_MATCH";
export const UPLOAD_RECEIPT_ACTION = "UPLOAD_RECEIPT";

export const ADD_MEMO_ACTION = "ADD_MEMO";

export const ANSWER_QUESTION_ACTION_PREFIX = "ANSWER_QUESTION";
export const ACTION_SEPARATOR = ":";

export const CATEGORY_RELATED_ACTIONS = [CATEGORIZE_ACTION];

export function getActionForQuestionKey(key: TaxQuestionKey): RequiredAction {
    return `${ANSWER_QUESTION_ACTION_PREFIX}${ACTION_SEPARATOR}${key}`;
}

export type RequiredAction =
    | typeof CATEGORIZE_ACTION
    | typeof TRANSFER_MATCH_ACTION
    | typeof UPLOAD_RECEIPT_ACTION
    | typeof ADD_MEMO_ACTION
    | `${typeof ANSWER_QUESTION_ACTION_PREFIX}${typeof ACTION_SEPARATOR}${TaxQuestionKey}`;
